/**
 * API data provider with cacheing.
 */
export class CacheProvider {
    private static instance = null;

    private cacheKeyPrefix = 'adena_';

    // 1 day default cache life
    private defaultExpiration = 1000 * 60 * 60 * 24;

    private store = window.localStorage;

    public static getInstance(): CacheProvider {
        if (null === CacheProvider.instance) {
            CacheProvider.instance = new CacheProvider();
        }
        return CacheProvider.instance;
    }

    /**
     * Wrapper to retrieve and cache data
     * @param key data key to store/retrieve
     * @param callback Function that returns a promise to retrieve the data
     * @param expiration optional custom expiration time
     */
    public async getCacheData(key: string, callback: Function, expiration?: number) {
        const cacheKey = this.cacheKeyPrefix + key;

        let data: { expires: number; value: any; } = null,
            refresh = false,
            cacheData = this.store.getItem(cacheKey);

        if (null === cacheData || window.isAdminLoggedIn) {
            refresh = true;
        } else {
            data = JSON.parse(cacheData);
            const now = new Date().getTime();

            if (now - data.expires > (expiration ? expiration : this.defaultExpiration) || !data.expires) {
                refresh = true;
            }
        }

        if (refresh) {
            return await callback().then(value => {
                data = {
                    expires : new Date().getTime() + (expiration ? expiration : this.defaultExpiration),
                    value : value
                }
                
                this.store.setItem(cacheKey, JSON.stringify(data));
                return data.value;
            });
        }

        return await new Promise(resolve => {
            resolve(data.value);
        });
    }
}
